import { computed, defineComponent } from 'vue';
import Datepicker from '@vuepic/vue-datepicker';
export default defineComponent({
    components: { Datepicker },
    props: {
        modelValue: [String, Date],
        placeholder: String,
        disabled: Boolean,
        disabledDate: Function,
        valueFormat: String,
        enableTimePicker: {
            type: Boolean,
            default: false
        },
        markers: {
            type: Array,
            default: () => {
                return [];
            }
        },
        minDate: {
            type: Date,
            default: new Date()
        }
    },
    emits: ['update:modelValue', 'updateMonthYear'],
    setup(props, { emit }) {
        const value = computed({
            get() {
                return typeof props.modelValue === 'string'
                    ? props.modelValue.includes('Z')
                        ? props.modelValue
                        : props.modelValue.concat('Z')
                    : props.modelValue;
            },
            set(value) {
                emit('update:modelValue', value);
            }
        });
        const updateMonthYear = ({ month, year }) => {
            emit('updateMonthYear', { month, year });
        };
        return { value, updateMonthYear };
    }
});
